<template>
    <div>
        <v-data-table 
            v-if="dashboardType === 'details'"
            :headers="tableHeaders"  :items="visibleReports" hide-default-footer  :server-items-length="totalReports"
            @item-selected="handleSelect" @toggle-select-all="handleSelectAll" 
            :loading-text="$t('loadingData')" :loading="reportsLoading">
            <template v-slot:top="{ }">
                <div class="d-flex">
                    <v-text-field prepend-inner-icon="mdi-magnify" style="width: 300px" outlined height="5px"
                        :placeholder="$t('search')" dense v-model="options.searchPhrase" @input="handleSearch" class="shrink"
                        clearable></v-text-field>

                    <v-spacer></v-spacer>
                    <div class="d-flex mr-5">
                        <v-btn color="primary" dark class="rounded-r-0" outlined @click="dashboardType = 'details'" >
                            <v-icon :color="dashboardType === 'details' ? 'primary' : 'gray'">mdi-menu</v-icon>
                        </v-btn>
                        <v-btn color="primary" dark class="rounded-l-0" outlined style="margin-left: -1px" @click="dashboardType = 'chart'">
                            <v-icon :color="dashboardType === 'chart' ? 'primary' : 'gray'">mdi-view-grid</v-icon>
                        </v-btn>
                    </div>

                    <div class="py-1 title">
                        {{ options.page }} - {{ totalPages }} {{ $t("of") }} {{ totalReports }}
                    </div>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1"
                        @click="pageChange(false)">
                        <v-icon dark> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages"
                        @click="pageChange(true)">
                        <v-icon dark> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                                <v-icon dark> mdi-cog-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-card width="417">
                            <v-list>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-list-item-title>{{$t("deforestation.customization")}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>
                                <div class="pl-3 pt-2 font-weight-normal">{{ $t("deforestation.recordsPerpage") }}</div>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-slider v-model="itemsPerPage" :tick-labels="itemsPerPageOptions"
                                            :max="3" step="1" ticks="always" tick-size="4"></v-slider>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-n3"></v-divider>
                            </v-list>
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col class="mt-n9" cols="6" v-for="header in headers" :key="header.value">
                                            <v-checkbox v-if="header.text" v-model="selectedHeaders"
                                                :label="header.text" color="primary" :value="header.text" hide-details
                                                :disabled="header.text == 'ID'"></v-checkbox>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-layout justify-center>
                                <v-card-actions class="mb-5">
                                    <v-spacer></v-spacer>
                                    <v-btn outlined color="primary" @click="resetDefaut" width="190">{{ $t("deforestation.restoreDefault") }}</v-btn>
                                    <v-btn color="primary" @click="resetTableStructure" width="190">{{ $t("deforestation.apply") }}</v-btn>
                                </v-card-actions>
                            </v-layout>
                        </v-card>
                    </v-menu>
                </div>
            </template>
            
            <template v-slot:item.goalNumber="{ item }">
                <span class="font-weight-medium">{{ item.goalNumber || "N/A" }}</span>
            </template>
            <template v-slot:item.title="{ item }">
                <span class="text-capitalize">{{ item.title || "N/A" }}</span>
            </template>
            <template v-slot:item.description="{ item }">{{ item.description || "N/A" }}</template>
            <template v-slot:item.icon="{ item }">
                <img :src="item.icon" alt="icon" width="60" height="60" class="mr-2 mt-2 mb-2 ml-2">
            </template>
        </v-data-table>

        <div v-else-if="dashboardType === 'chart'">
            <div class="d-flex mb-4">
                <v-text-field 
                    prepend-inner-icon="mdi-magnify" style="width: 300px" outlined height="5px"
                    :placeholder="$t('search')" dense v-model="options.searchPhrase" @input="handleSearch" class="shrink" clearable >
                </v-text-field>

                <v-spacer></v-spacer>
                
                <div class="d-flex mr-5">
                    <v-btn color="primary" dark class="rounded-r-0" outlined @click="dashboardType = 'details'" >
                        <v-icon :color="dashboardType === 'details' ? 'primary' : 'gray'">mdi-menu</v-icon>
                    </v-btn>
                    <v-btn color="primary" dark class="rounded-l-0" outlined style="margin-left: -1px" @click="dashboardType = 'chart'">
                        <v-icon :color="dashboardType === 'chart' ? 'primary' : 'gray'">mdi-view-grid</v-icon>
                    </v-btn>
                </div>

                <div class="py-1 title">
                    {{ options.page }} - {{ totalPages }} {{ $t("of") }} {{ totalReports }}
                </div>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page <= 1" @click="pageChange(false)">
                    <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn class="mx-2" fab small outlined color="primary" :disabled="options.page >= totalPages" @click="pageChange(true)">
                    <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" left :min-width="417">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs" v-on="on">
                            <v-icon dark> mdi-cog-outline</v-icon>
                        </v-btn>
                    </template>
                    <v-card width="417">
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>{{$t("deforestation.customization")}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                            <div class="pl-3 pt-2 font-weight-normal">{{ $t("deforestation.recordsPerpage") }}</div>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-slider v-model="itemsPerPage" :tick-labels="itemsPerPageOptions"
                                        :max="3" step="1" ticks="always" tick-size="4"></v-slider>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-n3"></v-divider>
                        </v-list>
                        <v-card-actions class="mb-5">
                            <v-spacer></v-spacer>
                            <v-btn outlined color="primary" @click="resetDefaut" width="190">{{ $t("deforestation.restoreDefault") }}</v-btn>
                            <v-btn color="primary" @click="resetTableStructure" width="190">{{ $t("deforestation.apply") }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </div>

            <div v-if="reportsLoading" class="text-center pa-8">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                <div class="mt-4">{{ $t('loadingData') }}</div>
            </div>

            <v-row v-else>
                <v-col v-for="item in visibleReports" :key="item.goalNumber" cols="12" sm="6" md="6" lg="3" xl="3" >
                    <v-card class="sdg-card" outlined hover @click="handleSelect(item)">
                        <div class="d-flex flex-column align-center pa-4">
                            <div class="mb-3">
                                <img :src="item.icon" alt="goal icon" width="80" height="80" class="sdg-icon">
                            </div>
                            <v-card-title class="text-center pa-2 text-h6">
                                <span class="text-capitalize">{{ item.title || "N/A" }}</span>
                            </v-card-title>
                            <v-card-text class="text-center pt-2">
                                <span class="grey--text text--darken-1">{{ truncateText(item.description, 120) }}</span>
                            </v-card-text>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
            <div v-if="!reportsLoading && visibleReports.length === 0" class="text-center pa-8">
                <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                <div class="mt-4 text-h6 grey--text">{{ $t('noDataAvailable') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import EsgService from "@/_services/EsgService";
import LoadingMixin from "@/mixins/LoadingMixin";

export default {
    name: "ReportList",
    mixins: [LoadingMixin],
    props: {
        toggleSelection: {
            type: Boolean,
        },
        toggleFilterState: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        reports(newReports) {
            this.localReports = newReports;
        },
    },
    computed: {
        totalPages() {
            return this.totalReports < this.options.limit ? 1 : Math.ceil(this.totalReports / this.options.limit);
        },
        dateRangeText() {
            return this.options.date.join(" - ");
        },
    },
    data() {
        return {
            dashboardType: "details",
            visibleReports: [],
            allReports: [],
            usableReports: [],
            reportsLoading: true,
            totalReports: 0,
            itemsPerPage: 0,
            itemsPerPageOptions: [10, 25, 50, 75, 100],
            selected: [],
            menu: false,
            selectedHeaders: [],
            search: "",
            options: {
                limit: 10,
                page: 1,
                searchPhrase: "",
                date: [],
                status: "",
                orderType: "DESC",
            },
            tableHeaders: [],
            headers: [
                {
                    text: this.$t("Number"),
                    align: "center",
                    value: "goalNumber",
                    class: "black--text",
                    width: '150px'
                },
                {
                    text: this.$t("Title"),
                    align: "start",
                    value: "title",
                    class: "black--text",
                },
                {
                    text: this.$t("Description"),
                    align: "start",
                    value: "description",
                    class: "black--text",
                },
                {
                    text: this.$t("Icon"),
                    align: "center",
                    value: "icon",
                    class: "black--text",
                },
                {
                    text: this.$t(""),
                    align: "center",
                    value: "",
                    class: "black--text",
                    width: '150px'
                },
            ],
        };
    },
    async created() {
        try {
            const { data } = await EsgService.getAllSDGGoals()
            this.allReports = data;
            this.usableReports = this.allReports;
            this.initializeData();
        } catch(e) {
            this.$notify({
                type: "error",
                text: "Failed to load ESG Reports"
            });
        } finally {
            this.reportsLoading = false;
        }
    },
    async mounted() {
        this.tableHeaders = this.headers;
        this.selectedHeaders = this.headers.map(h => h.text).filter(Boolean);
    },
    methods: {
        truncateText(text, maxLength) {
            if (!text) return "N/A";
            if (text.length <= maxLength) return text;
            return text.substring(0, maxLength) + "...";
        },
        initializeData() {
            this.totalReports = this.usableReports.length;
            this.visibleReports = this.usableReports.slice(0, this.options.limit);
            this.selectedHeaders = this.headers.map(header => header.text).filter(text => text !== 'ID');
        },
        handleSearch() {
            this.usableReports = this.allReports.filter((item) => item.title.toLowerCase().includes(this.options.searchPhrase.toLowerCase()));
            this.initializeData();
        },
        updateLimit() {
            this.options.limit = this.itemsPerPageOptions[this.itemsPerPage];
            this.options.page = 1;
            this.visibleReports = this.usableReports.slice(0, this.options.limit);
        },
        pageChange(t) {
            if (t) {
                this.options.page = this.options.page + 1;
            } else {
                this.options.page = this.options.page - 1;
            }
            const currentStartIndex = (this.options.page - 1) * this.options.limit;
            this.visibleReports = this.usableReports.slice(currentStartIndex, currentStartIndex + this.options.limit);
        },
        handleSelect(item) {
            this.$emit("select-report", item);
        },
        handleSelectAll(items) {
            this.$emit("select-all-reports", items);
        },
        resetTableStructure() {
            this.tableHeaders = this.headers.filter((header) =>
            (header.text && this.selectedHeaders.includes(header.text)) ||
            (!header.text));
            this.updateLimit()
            this.menu = false;
        },
        resetDefaut() {
            this.tableHeaders = this.headers;
            this.selectedHeaders = this.headers.map(header => header.text).filter(Boolean);
            this.itemsPerPage = 0;
            this.updateLimit();
            this.menu = false;
        },
    },
};
</script>

<style scoped>
.sdg-card {
    height: 100%;
    transition: all 0.3s ease;
}

.sdg-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.sdg-icon {
    border-radius: 8px;
}

.v-card__title {
    word-break: break-word;
    line-height: 1.4;
}
</style>